import { ApiError } from "../../../../../../../api/public/presentation"

const GENERIC_STALE_SLOT_MESSAGE =
  "Der ausgewählte Termin ist nicht mehr verfügbar. Die verfügbaren Zeiten wurden aktualisiert."

const BOOKING_CONFLICT_MESSAGES: Record<string, string> = {
  slot_time_conflict: GENERIC_STALE_SLOT_MESSAGE,
  slot_stale: GENERIC_STALE_SLOT_MESSAGE,
  slot_flex_quota_reached:
    "Für diesen Tag ist kein weiterer Flextermin möglich. Die verfügbaren Zeiten wurden aktualisiert.",
  slot_outside_working_hours:
    "Der ausgewählte Zeitraum passt nicht mehr zu den Terminregeln. Die verfügbaren Zeiten wurden aktualisiert.",
  slot_timeframe_invalid:
    "Der ausgewählte Zeitraum passt nicht mehr zu den Terminregeln. Die verfügbaren Zeiten wurden aktualisiert.",
  slot_route_incompatible:
    "Der Termin passt nicht mehr zur Route. Die verfügbaren Zeiten wurden aktualisiert.",
}

export const resolveSlotBookingConflictMessage = (error: unknown): string | null => {
  if (!(error instanceof ApiError) || error.status !== 409) return null

  const reasonCode = reasonCodeFromPayload(error.payload)

  if (!reasonCode) return GENERIC_STALE_SLOT_MESSAGE

  return BOOKING_CONFLICT_MESSAGES[reasonCode] ?? GENERIC_STALE_SLOT_MESSAGE
}

const reasonCodeFromPayload = (payload: unknown): string | null => {
  const record = asRecord(payload)

  if (!record) return null

  const directReason = stringValue(record.reason_code) ?? stringValue(record.reasonCode)

  if (directReason) return directReason

  const detail = asRecord(record.detail)

  if (!detail) return null

  return stringValue(detail.reason_code) ?? stringValue(detail.reasonCode)
}

const asRecord = (value: unknown): Record<string, unknown> | null => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null

  return value as Record<string, unknown>
}

const stringValue = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value.trim() : null
